import type { VAxios } from '../../define/axios/Axios';

export type AutoConvertInfo = {
  scan: boolean; // 是否扫码
  form: boolean; // 是否填过表单
  pod: boolean; // 是否有试用权限
  converted: boolean; // 是否有转化
  batch: boolean; // 是否有开通 pod 权限
};

export type GetWebsiteAutoConvertInfoRes = {
  gray: boolean; // 是否灰度
  info: AutoConvertInfo | null;
};

/**
 * 自主转化相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 获取转化信息
  getWebsiteAutoConvertInfo() {
    return defHttp.get<GetWebsiteAutoConvertInfoRes>({
      url: `/website/auto-convert/info`,
    });
  },
});
